import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';

export function GoBackButton({ history }: RouteComponentProps) {
  return (
    <button
      className="button--link"
      onClick={history.goBack}
      style={{ marginRight: '1rem' }}
      type="button"
    >
      <i className="fa fa-arrow-left back-button" />
    </button>
  );
}

export default withRouter(GoBackButton);